import { connect } from 'react-redux';
import ContextualSidebarView from './ContextualSidebarView';
import { isCollapsedSelector, isCollapsedWithButtonSelector } from './ContextualSidebarSelector';

export default Component =>
  connect((state, { className }) => ({
    isCollapsed: isCollapsedSelector(state),
    isCollapsedWithButton: isCollapsedWithButtonSelector(state),
    className,
    Component,
  }))(ContextualSidebarView);
